// Hook - lista handlowcow w panelu Administracji.
// GET /api/ui/trader-management/traders

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IGetTraderManagementTradersParams,
  IGetTraderManagementTradersResponse,
} from 'api/types/traderManagement';

const getTraderManagementTraders = (
  params: IGetTraderManagementTradersParams
): Promise<IGetTraderManagementTradersResponse> =>
  axios.get('/trader-management/traders', { params });

export const useGetTraderManagementTraders = (
  params: IGetTraderManagementTradersParams = {},
  options?: UseQueryOptions<IGetTraderManagementTradersResponse, IError>
) =>
  useQuery<IGetTraderManagementTradersResponse, IError>(
    ['trader-management-traders', params],
    () => getTraderManagementTraders(params),
    { keepPreviousData: true, ...(options ?? {}) }
  );
